import ValidationRule from './validation.rule.js';

const DEFAULT_LENGTH = 8;

/**
 * Check the length of a set of password input field and avoid form submission is length constraient is violated.
 * Note :
 * - if the rule's length and input's length are different, rule will override the input's length
 * - if no target field is specified, the rule will be applyied to all password <input> found in the following <form>
 */

class PasswordMinLengthRule extends ValidationRule {
    constructor(manager, settings = {}) {
        super(manager, settings);

        this.passwords = this.retrievePasswordElements(settings.target);

        this.length = settings.length || DEFAULT_LENGTH;

        this.passwords.forEach(passwordElt => {
            if (passwordElt.getAttribute('minlength') !== this.length) {
                passwordElt.setAttribute('minlength', this.length);
            }

            const target = this.loadTarget(passwordElt);
            this.listenValidity(target);
        });


    }

    clearValidity() {
        this.passwords.forEach(passwordElt => {
            this.resetValidity(passwordElt);
        });
    }

    /**
     * Generate an array of password HTMLElement giving string selector and element in mixed array
     * @param {string|undefined|(string|HTMLElement)[]} target
     * @return {HTMLElement[]}
     */
    retrievePasswordElements(target) {
        if (typeof target === 'undefined') {
            return Array.from(document.querySelectorAll(`#${this.getFormID()} input[type="password"]`));
        }

        else {
            if (Array.isArray(target) === false) {
                return this.retrievePasswordElements([ target ]);
            }

            else {
                return target.map(entry => {
                   if (typeof entry === 'string') {
                       return document.querySelector(entry);
                   }

                   else {
                       return entry;
                   }
                });
            }
        }
    }

    invalidate(eltToInvalidate) {
        const feedbackElt = this.getFeedbackElt(eltToInvalidate);
        if (feedbackElt !== null) {
            feedbackElt.textContent = this.getMessage();
        }

        eltToInvalidate.classList.add('is-invalid');

        // Do not setValidity ourself, let browser do it for us by adding minlength property to <input> tag
    }

    getMessage() {
        return `Passwords must at least have a size of ${this.length}`;
    }

    checkOne(passwordElt) {
        return passwordElt.value.length >= this.length;
    }

    async check() {
        return false && this.passwords.every(password => this.checkOne(password));
    }

    getRuleName() {
        return 'password-min-length';
    }
}

export default PasswordMinLengthRule;
